<template>
  <div class="text-left mt-4">
    <div>
      <VueSlider
        v-model="buttonSizeHeight"
        :min="0"
        :max="300"
        :tooltip="false"
      />
      Height: {{ $store.state.buttonSizeHeight }}
    </div>
    <div class="mt-4">
      <VueSlider
        v-model="buttonSizeWidth"
        :min="0"
        :max="600"
        :tooltip="false"
      />
      Width: {{ $store.state.buttonSizeWidth }}
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-3-slider-component'

export default {
  name: 'AppSlider',
  components: {
    VueSlider
  },
  computed: {
    buttonSizeHeight: {
      set(value) {
        this.$store.commit('setButtonSizeHeight', value)
      },
      get() {
        return this.$store.state.buttonSizeHeight
      }
    },
    buttonSizeWidth: {
      set(value) {
        this.$store.commit('setButtonSizeWidth', value)
      },
      get() {
        return this.$store.state.buttonSizeWidth
      }
    }
  }
}
</script>
